const TestimonialSection = ({ name, role, image, testimonial, isAlt }) => {
  return (
    <section className={`py-16 px-8 ${isAlt ? 'bg-white' : ''}`} style={{ backgroundColor: isAlt ? '#fff' : '#f2f4f7' }}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-4xl md:text-5xl font-light mb-2" style={{ color: '#2b3d57' }}>
            {name}
          </h2>
          <p className="text-xl" style={{ color: '#2b3d57' }}>
            {role}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-3">
            <img
              src={image}
              alt={name}
              className="w-full h-auto rounded"
              style={{ maxWidth: '300px' }}
            />
          </div>
          <div className="lg:col-span-9">
            <p className="text-base leading-relaxed" style={{ color: '#2b3d57' }}>
              {testimonial}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
